import { render, staticRenderFns } from "./BlogPostSubcategories.vue?vue&type=template&id=7985f04b&"
import script from "./BlogPostSubcategories.vue?vue&type=script&lang=ts&"
export * from "./BlogPostSubcategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports